type CountryCode = {name: string; dial_code: string; code?: string};

/**
 * Build picker items that lead with the dial code, then the country name
 * ("+91 · India"). Dial-code-first keeps the compact selected chip readable
 * (it always shows the dial code even when the name is clipped) while the
 * full label stays searchable by country name and disambiguates shared codes
 * (e.g. "+1" US/Canada vs "+1684").
 */
export const toCountryPickerItems = (
  countryCodes: CountryCode[],
): {label: string; value: string}[] =>
  countryCodes.map(c => ({
    label: `${c.dial_code} · ${c.name}`,
    value: c.dial_code,
  }));

/** Restore the last-used dial code so returning intl users don't re-select it. */
export const resolveInitialCountryCode = (
  stored: string | null | undefined,
): string => (stored && /^\+\d+$/.test(stored) ? stored : '+91');

type SendOtpResponse =
  | {success?: boolean; error?: string; tnc?: number}
  | undefined
  | null;

/**
 * react-query fires a mutation's onSuccess whenever the request resolves, even
 * for an app-level failure like "Onboarding halted". Callers must not treat
 * such a response as a sent OTP (which would start the resend timer).
 */
export const interpretSendOtpResponse = (
  response: SendOtpResponse,
): {onboardingHalted: boolean} => ({
  onboardingHalted:
    response?.success === false && response?.error === 'Onboarding halted',
});
